import { render, staticRenderFns } from "./AssetHandlerRoot.vue?vue&type=template&id=42360fc4"
import script from "./AssetHandlerRoot.vue?vue&type=script&lang=ts"
export * from "./AssetHandlerRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports